/* eslint-disable max-len, no-await-in-loop, no-new, no-unused-vars, padded-blocks */
/* eslint no-shadow: ["error", { "allow": ["state"] }] */
import api from '@/api';

export const namespaced = true;

export const state = {
  siteTaxlots: [],
};

export const actions = {
  async deleteSiteTaxlots({ commit }, siteTaxlotIds) {
    let id = siteTaxlotIds.pop();
    while (id) {
      await api.delete(`/sitetaxlot/${id}`).then(async (response) => {
        if (response.status === 200) {
          this.successMessage = 'The site taxlot has been successfully deleted.';
        }
      }).catch((error) => {
        console.error(error);
        this.serverError = error;
      });
      id = siteTaxlotIds.pop();
    }
  },
  async readSiteTaxlots({ commit }, siteId) {
    await api.get(`/sitetaxlot/site/${siteId}`).then((response) => {
      if (response.status === 200) {
        this.successMessage = 'The site taxlots have been successfully read.';
      }
      commit('SET_SITE_TAXLOTS', response.data);
    }).catch((error) => {
      console.error(error);
      this.serverError = error;
    });
  },
  async writeSiteAttributes({ commit }, params) {
    await api.put(
      `/site/${params.id}`,
      {
        siteAcreage: params.acreage,
        watershedId: params.watershedId,
        watershedName: params.watershedName,
        subwatershedId: params.subwatershedId,
        subwatershedName: params.subwatershedName,
      },
    ).then((response) => {}).catch((error) => {
      console.error(error);
      this.serverError = error;
    });
  },
  async writeSiteTaxlots({ commit }, parameters) {
    const siteTaxlots = parameters.siteTaxlots.map((siteTaxlot) => JSON.parse(JSON.stringify(siteTaxlot)));
    let siteTaxlot = siteTaxlots.pop();
    while (siteTaxlot) {
      const siteTaxlotModel = {
        relatedSite: parameters.siteId,
        recordName: '',
        acres: siteTaxlot.attributes.a_t_acres,
        county: siteTaxlot.attributes.county,
        taxlotGlobalId: siteTaxlot.attributes.GlobalID,
        taxlotId: siteTaxlot.attributes.tlid,
      };
      await api.post('/sitetaxlot', siteTaxlotModel).then(async (response) => {
        if (response.status === 200) {
          this.successMessage = 'The site taxlot has been successfully written.';
        }
      }).catch((error) => {
        console.error(error);
        this.serverError = error;
      });
      siteTaxlot = siteTaxlots.pop();
    }
  },
};

export const mutations = {
  SET_SITE_TAXLOTS(state, siteTaxlots) {
    state.siteTaxlots = siteTaxlots;
  },
};
